const TableEmptyRow = ({
  colSpan,
  message = "No results found",
  searchQuery = "",
  emptyMessage,
  searchMessage,
  onClearSearch,
  icon,
}) => {
  const displayMessage = searchQuery
    ? searchMessage || `No results found matching your search`
    : emptyMessage || message;

  return (
    <tr>
      <td colSpan={colSpan} className="px-4 py-8 text-center text-sm text-gray-500">
        {icon ? (
          <i className={`${icon} mb-2 block text-4xl text-gray-300`} />
        ) : null}
        <p>{displayMessage}</p>
        {searchQuery && onClearSearch ? (
          <button
            type="button"
            onClick={onClearSearch}
            className="mt-2 text-sm text-primary hover:text-primary/80"
          >
            Clear search
          </button>
        ) : null}
      </td>
    </tr>
  );
};

export default TableEmptyRow;
